import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export type ContainerProps = {
    showMenuAccount: boolean
}

export const Container = styled.div<ContainerProps>`
    display: ${({ showMenuAccount }) => (showMenuAccount ? 'flex' : 'none')};
    align-items: center;
    cursor: pointer;

    .dropdown-conta {
        position: absolute;
        top: 0;
        z-index: 1;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);

        svg {
            position: unset;
        }
    }

    @media (min-width: ${theme.breakpoints[0]}) {
        display: none;
    }
`

export const MenuList = styled.ul`
    height: 100vh;
    background: #0037ff;
    width: calc(100% - 55px);
    float: right;
    color: #fefefe;
    text-align: right;

    hr {
        color: #fefefe;
        float: right;
        width: 15.063rem;
    }
`

export const ContainerCloseDropdownIcon = styled.div`
    display: flex;
    padding: 1.25rem 0 1.875rem 1rem;
`

export const MenuContentContainer = styled.div`
    padding-right: 1rem;

    display: flex;
    flex-direction: column;
    align-items: flex-end;

    img {
        max-width: 4.686rem;
        max-height: 1.625rem;
    }

    a {
        text-decoration: none;
        text-decoration-line: none;
    }
`

export const MenuListItem = styled.li`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #0037ff;
    border: 0;
    height: 1.313rem;
    margin-bottom: 2rem;

    a > div > p {
        color: #fefefe;
    }
`
export const HeaderLogo = styled.img`
    margin-bottom: 2rem;
`

export const ButtonContainer = styled.div`
    button {
        height: 2rem;
        width: 10rem;
        margin-right: 1rem;
        margin-bottom: 2rem;

        background-color: #fefefe;
        color: #0037ff;
    }

    button:first-child {
        margin-top: 2rem;
    }
`
